import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { eventTracker } from '_helpers';

/**
 * @author Alireza Zebardast
 * @param {object} zone
 */
const HomePage = ({ config, zone }) => {
  const { zoneStr } = zone;
  const returnId = new URLSearchParams(window.location.hash.slice(1)).get('rc-bulk-payment');

  const {
    isMultiDistrict, shouldSeeDistrictSelector, districtId, webappConfig
  } = config;
  const {
    has_wgw = false,
    has_calendar = false,
    set_rap_landing_page,
    has_dz = false,
    has_bulk_pickup = false
  } = webappConfig;

  const history = useHistory();

  useEffect(() => {
    eventTracker('Plugin Visit');
  }, [zoneStr]);

  const routeBeforeZoneSetup = () => {
    if (returnId) {
      return history.push('/bulk-pickup', { returnId });
    }
    if (set_rap_landing_page) {
      return history.push('/help');
    }

    if (
      isMultiDistrict
      && shouldSeeDistrictSelector
    ) {
      return history.push('/select-districts');
    }

    if (
      !isMultiDistrict
      && districtId
      && has_wgw
      && !has_calendar
    ) return history.push('/wgw');

    if (
      !isMultiDistrict
      && districtId
      && !has_wgw
      && !has_calendar
      && has_dz
    ) return history.push('/education');

    if (!isMultiDistrict
      && districtId
      && !has_wgw
      && !has_calendar
      && !has_dz
      && has_bulk_pickup
    ) return history.push('/bulk-pickup');

    return history.push('/zone-setup');
  };

  const routeAfterZoneSetup = () => {
    if (returnId) {
      return history.push('/bulk-pickup', { returnId });
    }
    if (set_rap_landing_page) return history.push('/help');
    if (has_calendar) return history.push('/cal');
    if (has_wgw) return history.push('/wgw');
    if (has_dz) return history.push('/education');
    if (has_bulk_pickup) return history.push('/bulk-pickup');
    return history.push('/bulk-pickup');
  };

  return (
    <div>
      {
        (
          !has_calendar
          && !districtId
        )
          || (
            has_calendar
            && !zoneStr
          )
          ? routeBeforeZoneSetup() : routeAfterZoneSetup()
      }
    </div>
  );
};

export default HomePage;
